import { AppealStatus, TAppealStepByClass } from '../type'

export const appealStepByClass: TAppealStepByClass = {
  PREPROCESSING: 0,
  DEALER_SELECTED: 0,
  CANCELED: 0,
  VISIT_OFFER: 1,
  VISIT_PAID: 1,
  UNKNOWN: 1,
  OFFER: 2,
  OFFER_PAID: 2,
  WAITING_DEALER: 2,
  AWAITING_PAYMENT: 2,
  PROCESSING: 3,
  GRADE_WAITING: 3,
  SCHEDULED: 3,
  FIXING: 3,
  COMPLETED: 3,
}

// получение номера шага в заявке, исходя из статуса заявки
export const getAppealStepByClass = (status: AppealStatus) =>
  appealStepByClass[status]
